import React from 'react';
import classNames from 'classnames';

import { Correctness } from '../../../utils/constants';

interface IProps {
  content: string;
}

const FeedbackBadge = ({ content }: IProps) => {
  const finished = content === Correctness.Correct || content === Correctness.Incorrect;
  const displayContent =
    content === Correctness.Correct
      ? 'done'
      : content === Correctness.Incorrect
      ? 'close'
      : content;

  return (
    <div
      className={classNames('FeedbackBadge', {
        correct: content === 'correct',
        incorrect: content === 'incorrect',
      })}
    >
      <span className={classNames('FeedbackBadge-content', { 'material-icons': finished })}>
        {displayContent}
      </span>
    </div>
  );
};

export default FeedbackBadge;
